<div class="login">
  <div class="login__wrapper">
    <picture>
      <img src="../assets/images/Linkerweb_LogoFull_01.png" class="login__logo" alt="Logo" />
    </picture>

    <h1 class="login__title">Iniciar sesión</h1>

    <form [formGroup]="form" (submit)="login()" class="login__form">
      <div class="login__field">
        <label for="email" class="login__label">Usuario</label>
        <input
          formControlName="username"
          id="email"
          type="email"
          placeholder="Introduce tu usuario"
          class="login__input"
        />
      </div>

      <div class="login__field">
        <label for="pwd" class="login__label">Contraseña</label>
        <input
          formControlName="password"
          id="pwd"
          [type]="passwordVisible ? 'text' : 'password'"
          placeholder="Introduce tu contraseña"
          class="login__input login__input--password"
        />
        <button
          type="button"
          class="login__reveal"
          (click)="passwordVisible = !passwordVisible"
          [attr.aria-label]="passwordVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          [attr.aria-pressed]="passwordVisible"
        >
          <i class="pi" [class.pi-eye]="!passwordVisible" [class.pi-eye-slash]="passwordVisible"></i>
        </button>
      </div>

      <button type="submit" class="login__submit" [disabled]="!form.valid">Iniciar sesión</button>

      <a class="login__recover" routerLink="/reset-password">¿Olvidaste tu contraseña?</a>
    </form>
  </div>

  <picture>
    <img src="../assets/images/login-background.png" class="login__illustration" alt="Ilustración" />
  </picture>

  <picture>
    <img src="../assets/images/lnnova-links-dark.png" class="login__brand" alt="Logo Innovalinks" />
  </picture>
</div>
